<div [formGroup]="formGroup">
  <mat-form-field class="full-width">
    <mat-select [placeholder]="titulo" [formControlName]="controlName">
      <mat-option *ngFor="let opcao of opcoes" [value]="opcao">{{opcao}}</mat-option>
    </mat-select>
    <mat-error *ngIf="validacao.hasErrorValidar(formControl, 'required')">Campo obrigatório</mat-error>
  </mat-form-field>
</div>
